import { render, staticRenderFns } from "./DemoFileInputPrependIcon.vue?vue&type=template&id=48e614da&"
import script from "./DemoFileInputPrependIcon.vue?vue&type=script&lang=js&"
export * from "./DemoFileInputPrependIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
